import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: ", ";\n  min-width: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { Paper } from '@scp/ui-shared/components/Paper';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Spacing } from './Spacing';
export var CONTENT_BOX_MARGIN = 12; // we use margin and not flex because we need scrollbar in the furthest right position

export var ContentBoxWidth = css(_templateObject(), baselineToRem(240 + CONTENT_BOX_MARGIN * 2), baselineToRem(143 + CONTENT_BOX_MARGIN * 2));
var ContentWrapper = styled.div(_templateObject2(), ContentBoxWidth);
export var ContentBox = function ContentBox(_a) {
  var children = _a.children,
      contentAbove = _a.contentAbove,
      contentBelow = _a.contentBelow,
      _a$padding = _a.padding,
      padding = _a$padding === void 0 ? baselineToRem(8) : _a$padding,
      paperProps = __rest(_a, ["children", "contentAbove", "contentBelow", "padding"]);

  return React.createElement(ContentWrapper, null, React.createElement(Spacing, {
    margin: CONTENT_BOX_MARGIN
  }, contentAbove, React.createElement(Paper, Object.assign({
    padding: padding
  }, paperProps), children), contentBelow));
};